import { render, staticRenderFns } from "./competitiveTradeIn.vue?vue&type=template&id=509f06f0&scoped=true&"
import script from "./competitiveTradeIn.vue?vue&type=script&lang=tsx&"
export * from "./competitiveTradeIn.vue?vue&type=script&lang=tsx&"
import style0 from "./competitiveTradeIn.vue?vue&type=style&index=0&id=509f06f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509f06f0",
  null
  
)

export default component.exports